import { bootstrapApplication } from '@angular/platform-browser';
import { getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
import { fetchAndActivate, getRemoteConfig } from 'firebase/remote-config';
import { AppComponent } from './app/app.component.mjs';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

setTimeout(() => {
  console.log("isProd", environment.production);
  const app = getApp();
  getAuth(app);
  getFunctions(app);
  const remoteConfig = getRemoteConfig();
  remoteConfig.settings.minimumFetchIntervalMillis = 10000;
  fetchAndActivate(remoteConfig);
}, 1000);
